import request from '../../utils/request'
const urlParams = process.env.VUE_APP_UPLOAD_REAL_PATH
export default {
  // 获取楼栋全部列表
  houseAllList(data) {
    const params = data
    return request({
      url: urlParams + '/house-ridgepole/allList',
      type: 'get',
      params: params
    })
  },     
  // 获取楼栋列表
  houseList(data) {
    const params = data
    return request({
      url: urlParams + '/house-ridgepole/list',
      type: 'get',
      params: params
    })
  },  
 // 获取楼栋列表添加
  houseAddUp(data) {
    const params = data
    return request({
      url: urlParams + '/house-ridgepole/addUp',
      type: 'post',
      params: params,
      qs:false
    })
  },   
  importBatchHome(data) {
    const params = data
    return request({
      url: urlParams + '/import/batchHome',
      type: 'post',
      params: params,
      qs:false
    })
  },
   // 获取楼栋列表删除
   houseDel(data) {
    const params = data
    return request({
      url: urlParams + '/house-ridgepole/del',
      type: 'post',
      params: params
    })
  }, 
  // 获取楼层全部列表
  floorAllList(data) {
    const params = data
    return request({
      url: urlParams + '/house-floor/allList',
      type: 'get',
      params: params
    })
  },   
  // 获取楼层列表
  floorList(data) {
    const params = data
    return request({
      url: urlParams + '/house-floor/list',
      type: 'get',
      params: params
    })
  },  
 // 获取楼层列表添加
 floorAddUp(data) {
    const params = data
    return request({
      url: urlParams + '/house-floor/addUp',
      type: 'post',
      params: params,
      qs:false
    })
  },   
   // 获取楼层列表删除
   floorDel(data) {
    const params = data
    return request({
      url: urlParams + '/house-floor/del',
      type: 'post',
      params: params
    })
  },  
  // 获取单元全部列表
  unitAllList(data) {
    const params = data
    return request({
      url: urlParams + '/house-unit/allList',
      type: 'get',
      params: params
    })
  },   
  // 获取单元列表
  unitList(data) {
    const params = data
    return request({
      url: urlParams + '/house-unit/list',
      type: 'get',
      params: params
    })
  },  
 // 获取单元列表添加
 unitAddUp(data) {
    const params = data
    return request({
      url: urlParams + '/house-unit/addUp',
      type: 'post',
      params: params,
      qs:false
    })
  },   
   // 获取单元列表删除
   unitDel(data) {
    const params = data
    return request({
      url: urlParams + '/house-unit/del',
      type: 'post',
      params: params
    })
  },   
  // 获取房间全部列表
  roomAllList(data) {
    const params = data
    return request({
      url: urlParams + '/house-room/allList',
      type: 'get',
      params: params
    })
  },   
  // 获取房间列表
  roomList(data) {
    const params = data
    return request({
      url: urlParams + '/house-room/list',
      type: 'get',
      params: params
    })
  },  
 // 获取房间列表添加
 roomAddUp(data) {
    const params = data
    return request({
      url: urlParams + '/house-room/addUp',
      type: 'post',
      params: params,
      qs:false
    })
  },   
   // 获取房间列表删除
   roomDel(data) {
    const params = data
    return request({
      url: urlParams + '/house-room/del',
      type: 'post',
      params: params
    })
  }, 
  // 获取房间下用户列表
  roomUserList(data) {
    const params = data
    return request({
      url: urlParams + '/user-room/userList',
      type: 'get',
      params: params
    })
  },  

   // 获取用户房间绑定
   roombind(data) {
    const params = data
    return request({
      url: urlParams + '/user-room/bind',
      type: 'post',
      params: params
    })
  },   
   // 房间解绑
   roombindDel(data) {
    const params = data
    return request({
      url: urlParams + '/user-room/del',
      type: 'post',
      params: params
    })
  },  
   // 获取用户下的房间列表
   roombindRoomList(data) {
    const params = data
    return request({
      url: urlParams + '/user-room/roomList',
      type: 'get',
      params: params
    })
  },  
   // 人员信息房屋信息导入
   roomBatchImport(data) {
    const params = data
    return request({
      url: urlParams + '/user-room/batchImport',
      type: 'post',
      params: params,
      qs:false
    })
  },      
}